import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProductReveal } from './components/ProductReveal';
import { PatternBreak } from './components/PatternBreak';
import { MechanismSection } from './components/MechanismSection';
import { AntiAbandonoSection } from './components/AntiAbandonoSection';
import { IncludesSection } from './components/IncludesSection';
import { ForWhoSection } from './components/ForWhoSection';
import { TransformationSection } from './components/TransformationSection';
import { PricingCTA } from './components/PricingCTA';
import { FloatingCTA } from './components/FloatingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-[#0A0A0A] text-[#F5F5F5] selection:bg-[#25F4EE] selection:text-black" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <ProductReveal data-id="element-3" />
      <PatternBreak data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <AntiAbandonoSection data-id="element-6" />
      <IncludesSection data-id="element-7" />
      <ForWhoSection data-id="element-8" />
      <TransformationSection data-id="element-9" />
      <PricingCTA data-id="element-10" />
      <FloatingCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </main>;
}